import React, { useEffect, useState } from "react";
import userService from "../../services/user.service";
import DashboardMhesi from "../../components/home/forUser/deshboardMhesi";
import DashboardTqf from "../../components/home/forUser/deshboardTqf";
import { Path } from "../../constants/enum/path.emum";
import { Redirect } from "react-router-dom";

const DashboardUser = () => {
  //เช็กว่ามีหลักสูตรทั้งหมดที่ตนเองสังกัด มคอ หรือ อชว ไหม
  //ถ้ามีก็ให้ดึง DashboardTqf , DashboardMhesi มาแสดง
  const [tqf, setTqf] = useState(false);
  const [mhesi, setMhesi] = useState(false);

  const user = JSON.parse(localStorage.getItem("user") ?? "false");
  // console.log(user);
  useEffect(() => {
    (async () => {
      //ดำเนินการตรงนี้
      await userService.getId(user.id).then((res) => {
        res.data.curriculum.filter((item: any) => item.type === "tqf").length >
        0
          ? setTqf(true)
          : setTqf(false);

        res.data.curriculum.filter((item: any) => item.type === "mhesi")
          .length > 0
          ? setMhesi(true)
          : setMhesi(false);
      });
    })();
  }, []);
  // const user = JSON.parse(localStorage.getItem("user") ?? "false");
  if (user.role.name === "Admin") {
    return <Redirect to={Path.SCHEDULES} />;
  }

  return (
    <div className="container mt-2">
      {/* ถ้ามี มคอ. ให้เอา  DashboardTqf แสดง*/}
      {tqf && <DashboardTqf />}
      {/* ถ้ามี อชว. ให้เอา  DashboardMhesi แสดง*/}
      {mhesi && <DashboardMhesi />}
    </div>
  );
};

export default DashboardUser;
